module.exports = __webpack_public_path__ + "static/media/dotnetnuke-development.c10bfafb.png";